<nav
  class="navbar navbar-expand-lg navbar-light dev-theme position-absolute p-2"
>
  <a class="navbar-brand" href="#">
    <img
      src="assets/images/logo_lccv_icon.png"
      class="img-fluid mr-1"
      width="40px"
    />
    <div class="brand-text d-inline-block text-white">
      <strong>LCCV</strong>
    </div>
  </a>
</nav>
<div class="bg-logo"></div>
<div
  class="d-flex flex-column justify-content-center align-items-center"
  style="min-height: 100vh"
>
  <div class="badge-info rounded p-2">
    <div class="d-flex flex-row justify-content-center align-items-center">
      <h1
        class="mb-0 mr-3 pr-3 align-top border-right inline-block align-content-center"
      >
        Não implementado
      </h1>
      <h2 class="mb-0 font-weight-normal lead" id="desc">
        Funcionalidade em desenvolvimento.
      </h2>
    </div>
  </div>
</div>
